export function makeSubmitHomeSearchUseCase({ getUserData }) {
  return function submitHomeSearch({ search, router, emit }) {
    const user = getUserData?.();
    const group = user?.main_group?.name;

    if (!user || group !== "creator") {
      if (search?.length > 0) router.push({ name: "creadores", query: { query: search } });
      emit("update_proposals");
    } else {
      if (search?.length > 0) router.push({ name: "marcas", query: { query: search } });
      emit("update_casting_calls");
    }

    emit("update_search_query", search);
  };
}